import React from 'react';
import { Link } from 'react-router-dom';

// Components
import HtmlPage from './HtmlPage';

// Presentational Component
const RefHeader = () => {
	return (
		<div className="widget-ref-header">
			<HtmlPage page="Ref" />
			<p>See <Link to="/widgets/how">How Widgets Work</Link> for more details.</p>
		</div>
	);
};

export default RefHeader;



// WEBPACK FOOTER //
// ./src/components/widgets/RefHeader.js